import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages/App';

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);


const arr = [1, 2, 3];
const iAmJavascriptES6 = () => console.log(...arr);
window.iAmJavascriptES6 = iAmJavascriptES6;


// WEBPACK FOOTER //
// ./src/index.js